import { IDPrefixes } from '@griply/types';

import { hasCompositeIdPrefix } from '../encoded-ids/composite-id';
import { createPrefixId } from '../prefix-id';
import { GetGoalParentIdsOptions, GoalParentSource } from './get-goal-parents';

// `getGoalParentIds`' gate without the array: list rows ask this per item during layout.
export const hasGoalParent = (
  goal: GoalParentSource,
  { links }: GetGoalParentIdsOptions,
): boolean => {
  if (!goal.parentLinksMigrated) {
    return !!goal.ancestorIds?.[goal.ancestorIds.length - 1];
  }

  return !!links.outgoing[createPrefixId(goal.id, IDPrefixes.Goal)]?.some(
    (reference) => hasCompositeIdPrefix(reference, IDPrefixes.Goal),
  );
};
